// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"44dd1fe8","664":"eaaefebf","880":"0dadd797","941":"6977797f"}[chunkId] + ".js";
};